{
  ":root": {
    "--bg-primary": "#060818",
    "--primary": "#4361EE",
    "--card": "#0e1726",
    "--green": "#137E31",
    "--secondary": "#808080",
    "--input": "#1f1f2d",
    "--icon-bg": "#2F384C",
    "--border": "#5c5b5f",
    "--file-mask": "#201f2e",


    "--text-button-primary": "#efefef",
    "--text-button-secondary": "#fefefe",
    "--text-light": "#fefefe",
    "--text-normal": "#efefef",

    "--primary-hover": "#5b72df",
    "--card-hover": "rgba(26,26,26,0.8)",
    "--green-hover": "rgba(19,126,49,0.8)",
    "--secondary-hover": "rgba(128,128,128,0.8)",
    "--input-hover": "rgba(31,31,45,0.8)",
    "--border-hover": "rgba(92,91,95,0.8)",
    "--icon-hover": "rgba(47,56,76,0.8)",
    "--file-mask-hover": "rgba(32,31,46,0.8)",

    "--primary-disabled": "rgba(255,0,90,0.3)",
    "--card-disabled": "rgba(26,26,26,0.3)",
    "--green-disabled": "rgba(19,126,49,0.3)",
    "--secondary-disabled": "rgba(128,128,128,0.3)",
    "--input-disabled": "rgba(31,31,45,0.3)",
    "--icon-disabled": "rgba(47,56,76,0.3)",
    "--border-disabled": "rgba(92,91,95,0.3)",
    "--file-mask-disabled": "rgba(32,31,46,0.3)",

    "--success": "#40a043",
    "--reject": "#9F022E",
    "--info": "#DCC2FF",
    "--success-hover": "rgba(4,65,21,0.9)",
    "--reject-hover": "rgba(159,2,46,0.9)",
    "--info-hover": "rgba(220,194,255,0.9)",
    "--success-disabled": "rgba(4,65,21,0.3)",
    "--reject-disabled": "rgba(159,2,46,0.3)",
    "--info-disabled": "rgba(220,194,255,0.3)",

    "--dark": "#304060",
    "--white-dark": "#888ea8",

    "--p-1": "0.25rem",
    "--p-2": "0.5rem",
    "--p-4": "1rem",
    "--p-8": "2rem",

    "--m-1": "0.25rem",
    "--m-2": "0.5rem",
    "--m-4": "1rem",
    "--m-8": "2rem",
    "--m-16": "4rem",

    "--rounded-sm": "0.125rem",
    "--rounded-md": "0.375rem",
    "--rounded-xl": "0.75rem",
    "--bg-menu": "rgba(22,23,44,0.7)",
    "--bg-footer": "#0B0C1A"
  }
}